var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { push } from 'connected-react-router';
import { storeContainer } from '~utils/storeContainer';
import { selectAuthData } from '~slices/auth/selectors';
import { logout } from '~slices/auth';
import { filterParams } from '~utils/filterParams';
import { getPathWithLanguageCode } from '~utils/languageInURL';
import { refreshToken } from '~utils/refreshToken';
var baseURL = process.env.REACT_APP_BASE_URL || '';
function onLogout() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            storeContainer.store.dispatch(logout());
            if (!window.isWebView) {
                storeContainer.store.dispatch(push(getPathWithLanguageCode('/start')));
            }
            return [2 /*return*/];
        });
    });
}
function refreshTokenCall() {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, refreshToken()];
                case 1:
                    result = _a.sent();
                    if (!(result === null || result === void 0 ? void 0 : result.accessToken)) return [3 /*break*/, 2];
                    return [2 /*return*/, { accessToken: result.accessToken }];
                case 2: return [4 /*yield*/, onLogout()];
                case 3:
                    _a.sent();
                    return [2 /*return*/, null];
            }
        });
    });
}
export function executeRequest(_a) {
    var url = _a.url, _b = _a.options, options = _b === void 0 ? {} : _b, bodyData = _a.bodyData, formDataParam = _a.formDataParam, params = _a.params, setError = _a.setError;
    return __awaiter(this, void 0, void 0, function () {
        var state, token, headers, requestOptions, filteredData, formData_1, requestURL, urlParams, key, value, timeout, controller, timeoutId, response, newToken, error, _c, text_1, error, text, error_1, status_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    state = storeContainer.store.getState();
                    token = selectAuthData(state);
                    headers = new Headers(options.headers);
                    if (!headers.has('Authorization') && (token === null || token === void 0 ? void 0 : token.accessToken)) {
                        headers.set('Authorization', "Bearer ".concat(token.accessToken));
                    }
                    requestOptions = __assign(__assign({}, options), { headers: headers });
                    if (bodyData) {
                        headers.set('Content-Type', 'application/json');
                        filteredData = filterParams(bodyData);
                        requestOptions.body = JSON.stringify(filteredData);
                    }
                    if (formDataParam) {
                        formData_1 = new FormData();
                        Object.entries(formDataParam).forEach(function (_a) {
                            var key = _a[0], value = _a[1];
                            formData_1.append(key, value);
                        });
                        requestOptions.body = formData_1;
                    }
                    requestURL = url.startsWith('http') ? url : "".concat(baseURL).concat(url);
                    if (params) {
                        urlParams = new URLSearchParams();
                        for (key in params) {
                            value = params[key];
                            if (value) {
                                urlParams.append(key, value instanceof Date ? value.toISOString() : String(value));
                            }
                        }
                        requestURL += "?".concat(urlParams.toString());
                    }
                    timeout = 25000;
                    controller = new AbortController();
                    timeoutId = setTimeout(function () { return controller.abort(); }, timeout);
                    requestOptions.signal = controller.signal;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 14, , 15]);
                    return [4 /*yield*/, fetch(requestURL, requestOptions)];
                case 2:
                    response = _d.sent();
                    clearTimeout(timeoutId);
                    if (!(response.status === 401)) return [3 /*break*/, 7];
                    if (!!(token === null || token === void 0 ? void 0 : token.refreshToken)) return [3 /*break*/, 4];
                    return [4 /*yield*/, onLogout()];
                case 3:
                    _d.sent();
                    return [2 /*return*/, null];
                case 4: return [4 /*yield*/, refreshTokenCall()];
                case 5:
                    newToken = _d.sent();
                    if (!newToken) {
                        return [2 /*return*/, null];
                    }
                    headers.set('Authorization', "Bearer ".concat(newToken.accessToken));
                    return [4 /*yield*/, executeRequest({
                            url: url,
                            options: __assign(__assign({}, options), { headers: headers }),
                            bodyData: bodyData,
                            formDataParam: formDataParam,
                            params: params,
                            setError: setError,
                        })];
                case 6: return [2 /*return*/, _d.sent()];
                case 7:
                    if (!!response.ok) return [3 /*break*/, 12];
                    _d.label = 8;
                case 8:
                    _d.trys.push([8, 10, , 12]);
                    return [4 /*yield*/, response.json()];
                case 9:
                    error = (_d.sent());
                    setError === null || setError === void 0 ? void 0 : setError(error);
                    return [2 /*return*/, error];
                case 10:
                    _c = _d.sent();
                    return [4 /*yield*/, response.text()];
                case 11:
                    text_1 = _d.sent();
                    error = { error: text_1, status: response.status };
                    setError === null || setError === void 0 ? void 0 : setError(error);
                    return [2 /*return*/, error];
                case 12: return [4 /*yield*/, response.text()];
                case 13:
                    text = _d.sent();
                    return [2 /*return*/, {
                            status: response.status,
                            data: text ? JSON.parse(text) : undefined,
                        }];
                case 14:
                    error_1 = _d.sent();
                    clearTimeout(timeoutId);
                    console.error('Unexpected error:', error_1);
                    status_1 = 'status' in error_1 ? error_1.status : undefined;
                    setError === null || setError === void 0 ? void 0 : setError({ error: 'Unexpected error', status: status_1 });
                    return [2 /*return*/, null];
                case 15: return [2 /*return*/];
            }
        });
    });
}
